import { render, staticRenderFns } from "./AcousticLevitationViz.vue?vue&type=template&id=3036dadd&scoped=true"
import script from "./AcousticLevitationViz.vue?vue&type=script&lang=js"
export * from "./AcousticLevitationViz.vue?vue&type=script&lang=js"
import style0 from "./AcousticLevitationViz.vue?vue&type=style&index=0&id=3036dadd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3036dadd",
  null
  
)

export default component.exports